<div class="change-password-modal">
  <div class="modal-header align-items-center d-flex justify-content-between">
    <h4 class="modal-title mb-0">Change Password</h4>
    <button
      type="button"
      class="btn-close btn-close-white"
      aria-label="Close"
      [disabled]="saving()"
      (click)="close()"
    ></button>
  </div>

  <div class="modal-body">
    <p class="change-password-intro">
      Choose a strong password you do not use elsewhere. You will stay signed in
      after saving.
    </p>

    <form
      id="changePasswordForm"
      (ngSubmit)="submit()"
      #form="ngForm"
      autocomplete="off"
    >
      <div class="form-group">
        <label for="currentPassword" class="form-label">Current password</label>
        <div class="input-with-icon">
          <i class="bi bi-lock" aria-hidden="true"></i>
          <input
            type="password"
            class="form-control"
            id="currentPassword"
            name="currentPassword"
            placeholder="Enter current password"
            [ngModel]="currentPassword()"
            (ngModelChange)="currentPassword.set($event)"
            required
          />
        </div>
      </div>

      <div class="form-group">
        <label for="newPassword" class="form-label d-inline-flex align-items-center gap-1">
          New password
          <i
            class="bi bi-info-circle password-requirements-icon"
            role="button"
            tabindex="0"
            [ngbTooltip]="passwordRequirements"
            aria-label="Password requirements"
          ></i>
        </label>
        <div class="input-with-icon">
          <i class="bi bi-key" aria-hidden="true"></i>
          <input
            type="password"
            class="form-control"
            id="newPassword"
            name="newPassword"
            placeholder="Enter new password"
            [ngModel]="newPassword()"
            (ngModelChange)="newPassword.set($event)"
            required
          />
        </div>
      </div>

      <div class="form-group">
        <label for="confirmPassword" class="form-label">Confirm new password</label>
        <div class="input-with-icon">
          <i class="bi bi-key-fill" aria-hidden="true"></i>
          <input
            type="password"
            class="form-control"
            id="confirmPassword"
            name="confirmPassword"
            placeholder="Confirm new password"
            [ngModel]="confirmPassword()"
            (ngModelChange)="confirmPassword.set($event)"
            required
          />
        </div>
      </div>

      @if (error()) {
        <div class="alert alert-danger change-password-error" role="alert">
          {{ error() }}
        </div>
      }
    </form>
  </div>

  <div class="modal-footer d-flex justify-content-end">
    <button
      type="button"
      class="btn btn-outline-secondary"
      [disabled]="saving()"
      (click)="close()"
    >
      Cancel
    </button>
    <button
      type="submit"
      form="changePasswordForm"
      class="btn btn-primary d-inline-flex align-items-center justify-content-center gap-2"
      [disabled]="!isFormValid() || saving()"
    >
      @if (!saving()) {
        Save password
      } @else {
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        <span>Saving…</span>
      }
    </button>
  </div>
</div>
